import React, { Fragment, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Button, Form, FormGroup, Input, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { printExpense } from '../../../../utils/printers/Expense';
import {
  getCheckExpenseItinerary,
  getPreviewTripExpense,
} from '../../../../actions';
import Modal from '../../../common/modal/Modal';
import PreviewTripExpense from './PreviewTripExpense';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { GET } from '../../../../config/permissions';
import { generateGetPreviewTripEndpoint } from '../../../../config/endpoints';
import { ITINERARY_EXPENSE_ALERT_TYPE } from '../../../../config/constants';
import { postTripExpense } from '../../../../actions/sales';

const PrintExpenseButton = ({
  itinerary,
  drivers,
  dispatchPostTripExpense,
  dispatchGetPreviewTripExpense,
  dispatchGetCheckExpenseItinerary,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);
  const [disableConfirmButton, setDisableConfirmButton] = useState(true);
  const [driverId, setDriverId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isExistExpenseItinerary, setIsExistExpenseItinerary] = useState(false);

  // isTripExpenseByCircuit is validated about
  // https://civa.atlassian.net/browse/FLIT-2879
  const isTripExpenseByCircuit = useMemo(() => {
    const { circuitId, routeId } = itinerary.toJS();

    return (
      (circuitId === 156 && (routeId === 365 || routeId === 366)) || // LIMA - HUARAZ - LIMA
      (circuitId === 318 && (routeId === 778 || routeId === 779)) || // LIMA SUPERCIVA/ECONOCIVA - HUANCAYO - LIMA SUPERCIVA/ECONOCIVA
      (circuitId === 101 && (routeId === 391 || routeId === 381)) || // LIMA - MARCONA - LIMA
      (circuitId === 448 && (routeId === 951 || routeId === 952)) || // LIMA - OXAMPAMPA - LIMA
      (circuitId === 319 && (routeId === 778 || routeId === 780)) || // LIMA EXCLUCIVA - HUANCAYO - LIMA EXCLUCIVA
      (circuitId === 83 && (routeId === 380 || routeId === 374)) || // LIMA - AYACUCHO
      (circuitId === 275 && (routeId === 727 || routeId === 728)) || // LIMA PLAZA NORTE - MARCONA - LIMA PLAZA NORTE
      (circuitId === 551 && (routeId === 570 || routeId === 1016)) || // LIMA EXCLUCIVA - HUARAZ - LIMA EXCLUCIVA
      (circuitId === 553 && (routeId === 1117 || routeId === 1118)) || // LIMA EXCLUCIVA - OXAPAMPA - LIMA EXCLUCIVA
      (circuitId === 576 && (routeId === 1154 || routeId === 1155)) || // LIMA EXCLUCIVA - HUANCAYO - LIMA EXCLUCIVA
      (circuitId === 586 && (routeId === 1117 || routeId === 952)) || // LIMA OXAPAMPA - OXAPAMPA - LIMA
      (circuitId === 494 && (routeId === 1035 || routeId === 1036)) || // LIMA OXAPAMPA - OXAPAMPA - LIMA
      (circuitId === 461 && (routeId === 966 || routeId === 965)) || // LIMA HUANCAYO - HUANCAYO - LIMA
      (circuitId === 442 && (routeId === 946 || routeId === 947)) // LIMA OXAPAMPA - OXAPAMPA - LIMA
    );
  }, [itinerary]);

  const handleChangeDriver = (e) => {
    const {
      currentTarget: { value },
    } = e;

    if (value !== '') {
      setDisableConfirmButton(false);
      setDriverId(value);
    } else {
      setDisableConfirmButton(true);
      setDriverId(0);
    }
  };

  const onHandlePrintExpense = async () => {
    const driverOptions = drivers.map(({ driverId: id, driverName }) => (
      <option key={id.toString()} value={id}>
        {driverName}
      </option>
    ));

    const tripExpenseList = await dispatchGetPreviewTripExpense(
      { itineraryId: itinerary.get('id') },
      isTripExpenseByCircuit,
    );

    setLoading(false);

    if (tripExpenseList && tripExpenseList.length > 0) {
      const itineraryText = isTripExpenseByCircuit
        ? 'estos Itinerarios'
        : 'este Itinerario';

      const body = (
        <Row>
          <Col sm={12} md={12} lg={7}>
            <h5>Vista Previa - Gastos de Viaje</h5>
            <PreviewTripExpense expenseList={tripExpenseList} />
          </Col>
          <Col sm={12} md={12} lg={5}>
            <p className="text-justify">
              ¿Está seguro que desea generar Gastos de Viaje para{' '}
              {itineraryText}? Esta acción DESCONTARÁ DINERO DE SU CAJA de forma
              automática.
            </p>
            <p className="text-justify">
              Seleccione al Conductor que cobra para generar los Gastos de
              Viaje.
            </p>
            <Form>
              <FormGroup row>
                <Col>
                  <Input
                    type="select"
                    name="driver"
                    id="driver"
                    onChange={handleChangeDriver}
                  >
                    <option value="">Seleccione</option>
                    {driverOptions}
                  </Input>
                </Col>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      );

      setShowModal(true);
      setModalBody(body);
    }
  };

  const onHandleAlertExistingExpense = async (expenseList) => {
    expenseList.forEach((expense) => {
      const { documentSeries } = expense;
      const documentCode = expense.documentCode.toString().padStart(7, '0');

      toastr.warning(
        'Atención',
        `Ya se había registrado un gasto de viaje para este itinerario, Egreso: ${documentSeries}-${documentCode}. se generará uno nuevo.`,
        {
          timeOut: 0,
          showCloseButton: true,
          progressBar: true,
          removeOnHover: false,
        },
      );
    });

    await onHandlePrintExpense();
  };

  const onHandleReprintExpense = () => {
    const driverArray = drivers.toArray();

    const body = (
      <>
        <p className="text-justify">
          El Itinerario seleccionado ya generó un Gasto de Viaje previamente.
        </p>
      </>
    );

    setLoading(false);
    setIsExistExpenseItinerary(true);
    setDisableConfirmButton(false);
    setDriverId(driverArray[0].driverId);
    setShowModal(true);
    setModalBody(body);
  };

  const onClickPreview = async () => {
    setLoading(true);

    const { type, expenseList } = await dispatchGetCheckExpenseItinerary({
      itineraryId: itinerary.get('id'),
    });

    if (type === ITINERARY_EXPENSE_ALERT_TYPE.REPRINT.value) {
      onHandleReprintExpense();
    } else if (type === ITINERARY_EXPENSE_ALERT_TYPE.PRINT.value) {
      await onHandlePrintExpense();
    } else if (
      type === ITINERARY_EXPENSE_ALERT_TYPE.ALERT_EXISTING_EXPENSE.value
    ) {
      await onHandleAlertExistingExpense(expenseList);
    }
  };

  const onClickGenerateTripExpense = async () => {
    const driverPayeeId = driverId;

    const otherDrivers = drivers
      .filter((driver) => Number(driver.driverId) !== Number(driverPayeeId))
      .toJS();

    const secondDriverPayeeId = otherDrivers[0]
      ? otherDrivers[0].driverId
      : null;

    const thirdDriverPayeeId = otherDrivers[1]
      ? otherDrivers[1].driverId
      : null;

    const tripExpenseData = {
      itineraryId: itinerary.get('id'),
      driverPayeeId: Number(driverPayeeId),
      secondDriverPayeeId,
      thirdDriverPayeeId,
    };

    const tripExpenseList = await dispatchPostTripExpense(
      tripExpenseData,
      isTripExpenseByCircuit,
    );

    if (tripExpenseList && tripExpenseList.length > 0)
      printExpense(tripExpenseList, drivers.toJS(), isExistExpenseItinerary);
  };

  const loadingIcon = loading ? (
    <i className="fa fa-spinner fa-spin fa-fw" />
  ) : (
    <i className="fa fa-print" />
  );

  const modalConfirmButtonText = !isExistExpenseItinerary
    ? 'Generar Gastos de Viaje'
    : 'Reimprimir Gastos de Viaje';

  return (
    <Fragment>
      <Modal
        show={showModal}
        title="Confirmación"
        body={modalBody}
        onClickConfirm={() => onClickGenerateTripExpense()}
        onClickCancel={() => setShowModal(false)}
        onClickClose={() => setShowModal(false)}
        confirmButtonText={modalConfirmButtonText}
        cancelButtonText="Cancelar"
        size="lg"
        disableConfirmButton={disableConfirmButton}
      />
      <Button color="light" className="border" onClick={onClickPreview}>
        {loadingIcon} Gastos de Viaje
      </Button>
    </Fragment>
  );
};

PrintExpenseButton.propTypes = {
  itinerary: PropTypes.instanceOf(Immutable.Map).isRequired,
  drivers: PropTypes.instanceOf(Immutable.Set).isRequired,
  dispatchPostTripExpense: PropTypes.func.isRequired,
  dispatchGetPreviewTripExpense: PropTypes.func.isRequired,
  dispatchGetCheckExpenseItinerary: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  itinerary: ItineraryUnit.Itinerary.getIn(['current', 'content']),
});

const mapDispatchToProps = {
  dispatchPostTripExpense: postTripExpense,
  dispatchGetPreviewTripExpense: getPreviewTripExpense,
  dispatchGetCheckExpenseItinerary: getCheckExpenseItinerary,
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrintExpenseButton);

export default withEndpointAuthorization({
  url: generateGetPreviewTripEndpoint(0),
  permissionType: GET,
})(connectedComponent);
